import { FaArrowRightLong } from 'react-icons/fa6';
import AnchorLink from '../AnchorLink';
import Container from '../Container';
import Heading from '../Heading';
import Card from './Card';
import styles from './styles.module.css'

const Blog = () => {
    return (
        <section className={`${styles['section-9']} bg-secondary-black py-5`}>
            <Container className="py-0 py-lg-4">
                <div className='row'>
                    <div className='col-12'>
                        <Heading 
                            heading={'Our Blog'}
                        />
                    </div>
                </div>

                <div className='row my-5'>
                    <Card />
                    <Card />
                    <Card />
                    <Card />
                    <Card />
                    <Card />
                </div>

                <div className='text-center'>
                    <AnchorLink 
                        icon={<FaArrowRightLong className='ms-2' size={20}/>}
                        iconPostion='right'
                        title={'All Articles'}
                        href={'#!'}
                    />
                </div>
            </Container>
        </section>
    );
};

export default Blog;